import React from "react";

import { cn } from "./utils/cn";

export const Select = React.forwardRef(function Select(
  { className, style, ...props }: React.ComponentProps<"select">,
  ref: React.ForwardedRef<HTMLSelectElement>
) {
  return (
    <div className={cn("relative", className)} style={style}>
      <select
        {...props}
        className={cn(
          "appearance-none bg-[#E8E8E8] w-full h-11 px-3 rounded-lg placeholder:text-[#979797] border-b border-b-primary-1 text-sm"
        )}
        ref={ref}
      />
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-1/2 -translate-y-1/2 right-4 pointer-events-none"
      >
        <path d="M5.22 8.22a.749.749 0 0 0 0 1.06l6.25 6.25a.749.749 0 0 0 1.06 0l6.25-6.25a.749.749 0 1 0-1.06-1.06L12 13.939 6.28 8.22a.749.749 0 0 0-1.06 0Z"></path>
      </svg>
    </div>
  );
});
